import * as React from "react";
const SvgInventory20Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        fill: "none",
        viewBox: "0 0 20 20"
      },
      props
    ),
    React.createElement("path", {
      d: "M8 16H6V12H8V16Z",
      fill: "#2C2B2A"
    }),
    React.createElement("path", {
      d: "M11 16H9V12H11V16Z",
      fill: "#2C2B2A"
    }),
    React.createElement("path", {
      d: "M14 16H12V12H14V16Z",
      fill: "#2C2B2A"
    }),
    React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M14 4.86328C16.209 4.86341 17.9999 6.65428 18 8.86328C18 8.90901 17.9976 8.95464 17.9961 9H19V19H1V9H2V4H6V1H14V4.86328ZM3 17H17V11H3V17ZM4 9H6V6H4V9ZM8 9H10.0029C10.0014 8.95465 10 8.90901 10 8.86328C10 7.38294 10.8047 6.09111 12 5.39941V3H8V9ZM14 6.86328C12.8955 6.86328 12.0001 7.75877 12 8.86328C12 8.90925 12.0038 8.95481 12.0068 9H15.9932C15.9962 8.95482 16 8.90924 16 8.86328C15.9999 7.75885 15.1044 6.86341 14 6.86328Z",
      fill: "#2C2B2A"
    })
  );
export default SvgInventory20Px;
